import React from 'react';
import background from '../../assets/kelp.jpg';
import ReusableInfoCard from '../../components/ReusableInfoCard/ReusableInfoCard';


class InfoKelp extends React.Component {
  render () { 
   return(
  
  <ReusableInfoCard             
    
        tag="OCEANS"
        subtag="THREATENED"
        description="Kelp Forests"
        paragraph="Warming water, stronger storms, Over-harvesting. and pollution are taking a toll on the sustainability of kelp forests.These forests provide food and habitat for nearshore ecosystems."
        background={background}
     />
  
  );
 }
}   

export default InfoKelp;